import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { ApiResponse } from '@core/types';
import { Account, AccountDetail, AccountCreate, AccountUpdate } from '@core/types/finance.type';

@Injectable({ providedIn: 'root' })
export class AccountService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.api}/finance/accounts`;

  getAccounts(): Observable<ApiResponse<Account[]>> {
    return this.http.get<ApiResponse<Account[]>>(this.apiUrl);
  }

  getAccount(id: string): Observable<ApiResponse<AccountDetail>> {
    return this.http.get<ApiResponse<AccountDetail>>(`${this.apiUrl}/${id}`);
  }

  createAccount(data: AccountCreate): Observable<ApiResponse<string>> {
    return this.http.post<ApiResponse<string>>(this.apiUrl, data);
  }

  updateAccount(data: AccountUpdate): Observable<ApiResponse<void>> {
    return this.http.put<ApiResponse<void>>(this.apiUrl, data);
  }

  deleteAccount(id: string): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.apiUrl}/${id}`);
  }
}
